import { observable, action, makeAutoObservable } from "mobx"
import { GetRelatedAccounts } from './Requests/GetRelatedAccounts'

class RelatedAccsStore {
  @observable relatedAccounts = []
  ReletedAccount = true;
  ReletedAccountMain = true;

  constructor() {
    makeAutoObservable(this)
  }

  SetRelatedAccountFlag(){
    this.ReletedAccount = false;
  }

  SetRelatedAccountMainFlag(){
    this.ReletedAccountMain = false;
  }

  @action async getRelatedAccounts(userId, access) {
    await GetRelatedAccounts(userId, access)
  }

  @action async setRelatedAccounts(data) {
    this.relatedAccounts = data;
    this.ReletedAccount = true;
    this.ReletedAccountMain = true;
  }
}

const relatedAccsStore = new RelatedAccsStore()

export default relatedAccsStore